import { render, staticRenderFns } from "./searchpro.vue?vue&type=template&id=67d73ef4&"
import script from "./searchpro.vue?vue&type=script&lang=js&"
export * from "./searchpro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports